import {get} from "./common";

export const vendorGetTopProducts = async (from, to) => {
    try {
        return await get(`/vendor/dashboard/top-products?from=${from}&to=${to}`);
    } catch (error) {
        return null;
    }
};

export const vendorGetRfpData = async (from, to) => {
    try {
        return await get(`/vendor/dashboard/rfp-data?from=${from}&to=${to}`);
    } catch (error) {
        return null;
    }
};


export const vendorGetChartData = async (route, from, to) => {
    try {
        return await get(`/vendor/dashboard/${route}?from=${from}&to=${to}`);
    } catch (error) {
        return null;
    }
};